<script setup lang="ts">
import { FormKitMessages } from "@formkit/vue";
import type { HTMLAttributes } from "vue";

const { fixedHeight, isForm, dataCy } = defineProps<{
  isForm?: boolean;
  fixedHeight?: boolean;
  dataCy?: string;
  dataTest?: string;
  disableBodyPadding?: boolean;
  preventOverflow?: boolean;
}>();

type Slots = {
  title?(): any;
  subtitle?(): any;
  buttons?(): any;
  content?(): any;
};

const slots = defineSlots<Slots>();

const classes = computed(() => {
  const heightClass = fixedHeight
    ? "h-dvh md:min-h-[670px] md:max-h-[670px]"
    : "h-auto";

  return `w-dvw md:w-[500px] p-0! relative flex ${heightClass}`;
});

const formProps = computed(() =>
  isForm
    ? {
        type: "form",
        actions: false,
        formClass: ` ${classes.value}`,
        dataCy: dataCy,
      }
    : {},
);

const isSoloContent = computed(
  () => !slots.title && !slots.subtitle && !slots.buttons,
);

const attrs: HTMLAttributes = useAttrs();
</script>

<template>
  <component
    v-bind="{ ...formProps, ...attrs }"
    :is="isForm ? 'FormKit' : 'div'"
    :data-test="dataTest"
    :class="classes"
    :data-cy="dataCy"
  >
    <div
      class="flex flex-col flex-1 overflow-hidden"
      :class="{
        '!pb-0': !slots.buttons,
      }"
    >
      <div
        class="overflow-auto flex flex-col flex-1"
        :class="{
          '!overflow-hidden': preventOverflow,
        }"
      >
        <BaseDialogHeader>
          <template
            v-if="slots.title"
            #title
          >
            <slot name="title" />
          </template>
          <template
            v-if="slots.subtitle"
            #subtitle
          >
            <slot name="subtitle" />
          </template>
        </BaseDialogHeader>

        <div
          class="dialog-body px-6 flex-1 flex flex-col pb-6"
          :class="{
            '!px-0': disableBodyPadding,
            '!justify-center': isSoloContent,
            '!overflow-hidden': preventOverflow,
          }"
        >
          <slot name="content" />

          <FormKitMessages />
        </div>
      </div>
      <BaseDialogFooter v-if="slots.buttons">
        <slot name="buttons" />
      </BaseDialogFooter>
    </div>
  </component>
</template>

<style lang="postcss" scoped>
form {
  @apply flex flex-col flex-1;
}
</style>
